const clearConsole = (): void => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  if (window.console || (window.console as any).firebug) {
    // eslint-disable-next-line no-console
    console.clear();
  }
};

export default clearConsole;
